/// <reference path="./meevoTheming.section.base.ts" />

module Meevo.Plugins.MeevoTheming {
    "use strict";
    import BusinessInfoDataService = Meevo.Components.Common.BusinessInfoDataService;
    /**
    * sub section of Meevo Color Themes
    */
    export class DataMaintSection extends MeevoThemingSectionBase {
        protected $http: angular.IHttpService;
        private taskbarColor: string;
        private taskbarTabsColor: string;
        private previoustheme: number;
        private respObj: any;
        private themeCss: string;
        public saveFunction: any;
        public cancelFunction: any;
        constructor(sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            context: MeevoThemingContext,
            saveFunction: any,
            cancelFunction: any,
            sectionSecurityKey?: string,
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, context, saveFunction, cancelFunction, sectionSecurityKey);
            let uri = `/storagedrv/${this.tenantId}/styles/meevo.json`
            this.dataService.customMethodData(uri, 'GET', '', '')
                .then((response) => {
                    this.respObj = response.data;
                    let colors = this.respObj["colors"];

                    this.model = response.data;
                    this.activate();

                    if (colors["dataMaintTheme"]) {
                        this.previoustheme = colors["dataMaintTheme"]
                        this.themes[this.previoustheme].enabled = false;
                    } else {
                        this.previoustheme = 0;
                        this.themes[0].enabled = false;
                    }




                }).catch((err: any) => { console.log("getThemeCss"); });


        }

        activate(): void {
            super.activate();
            if (this.identityService.current().isSingleLocation ||
                this.identityService.current().centralOfficeId == this.identityService.current().locationId) {
                if (Model.Guard.isNothing(this.model.businessTypeDetail)) {
                    this.model.businessTypeDetail = {};
                    this.model.businessTypeDetail.id = this.identityService.businessTypeId;
                }
            }
        }

        themeSelected = 0

        themes = [
            {
                name: "Default",
                color1: "#D1C3E0",
                color2: "#B29DCB",
                color3: "#863B96",
                enabled: undefined
            },
            {
                name: "Neutral Modern",
                color1: "#E2E2E2",
                color2: "#8E8E8E",
                color3: "#232323",
                enabled: undefined
            },
            {
                name: "Neutral Earth",
                color1: "#C9C7C0",
                color2: "#938E86",
                color3: "#3F3325",
                enabled: undefined
            },
        ]

        themesCss = [
            {
                name: "Neutral Default",
                meevo_bottom_tray: "#EDE7F6",
                maint_side_nav: "#D1C4E9",
                nav_buttons_active: "#8E24AA",
                nav_buttons: "#B39DDB",
                search_again: "#5E35B1",
                maint_subheader: "#EDE7F6",
                meevo_button: "#B39DDB",
                hover: "rgba(142, 36, 170, 0.5)"

            },
            {
                name: "Neutral Modern",
                meevo_bottom_tray: "#434343",
                maint_side_nav: "#E2E2E2",
                nav_buttons_active: "#232323",
                nav_buttons: "#8E8E8E",
                search_again: "#3D3D3D",
                maint_subheader: "#F2F2F2",
                meevo_button: "#878787",
                hover: "#adacac"

            },
            {
                name: "Neutral Earth",
                meevo_bottom_tray: "#3F382B",
                maint_side_nav: "#C9C7C0",
                nav_buttons_active: "#3F3325",
                nav_buttons: "#938E86",
                search_again: "#47423B",
                maint_subheader: "#EFEFEF",
                meevo_button: "#8C877D",
                hover: "#afa89f"
            }

        ]

        private themeChanged = (index, readOnly) => {
            if (readOnly) {
                return;
            }
            if (index !== 0) this.themes[0].enabled = undefined;
            if (index !== 1) this.themes[1].enabled = undefined;
            if (index !== 2) this.themes[2].enabled = undefined;

            this.themeSelected = index;

            this.applyCss(index);

        }

        applyCss(index) {

            let meevo_bottom_tray = `.meevo_save_delete_bottom_tray{background-color: ${this.themesCss[index].meevo_bottom_tray} }`
            let maint_side_nav = `.maint-side-nav{background-color: ${this.themesCss[index].maint_side_nav}}`
            let nav_buttons_active = `.nav_buttons_active{ background-color: ${this.themesCss[index].nav_buttons_active} !important}`
            let nav_buttons = `.nav-buttons{ background-color: ${this.themesCss[index].nav_buttons}}`
            let maint_subheader = `.maint-subheader .maint-name{background-color: ${this.themesCss[index].maint_subheader}}`
            let meevo_button = `.meevo_save_delete_bottom_tray .meevo-button{background-color: ${this.themesCss[index].meevo_button}}`
            let hover = `.nav-buttons:hover{ background-color: ${this.themesCss[index].hover}}`
            let search_again = `.maint-subheader .search-again{background-color: ${this.themesCss[index].search_again}}`

            //angular11 classes
            let a11_side_buttons_selected = `.mil-data-detail__section--selected{background-color:${this.themesCss[index].nav_buttons_active} !important }`;
            let a11_side_buttons_not_selected = `.maint-side-nav .mil-data-detail__section{background-color: ${this.themesCss[index].nav_buttons}}`;
            let a11_nav_hover = `.mil-data-detail .nav-buttons:hover{background-color: ${this.themesCss[index].hover}}`;
            let a11_search_again = `.mil-data-detail__sections .search-again{background-color: ${this.themesCss[index].search_again}}`
            let a11_mil_data_command_tray = `.mil-data-detail .mil-data-command-tray{background-color: ${this.themesCss[index].meevo_bottom_tray}}`;
            let a11_meevo_tray_buttons = `.mil-data-detail .mil-data-command-tray button{background-color: ${this.themesCss[index].meevo_button}}`;

            //mobile
            let mobileSaveButton = `#maint-crud-mobile .meevo-button {background-color: ${this.themesCss[index].meevo_button}}`;
            let mobileHamburger = `#showMobileMenuButton { background-color: ${this.themesCss[index].meevo_button} !important}`;

            //angular11 mobile
            let a11_hamburger = `.mil-data-detail .available-list-wrapper .hamburger_menu{ background-color: ${this.themesCss[index].meevo_button} !important}`;
            let a11_hamburgerButtons = `.mil-data-detail .nav-buttons{background-color: ${this.themesCss[index].nav_buttons}} `;


            // themeCss SINGULAR without s not confused with themesCss is the whole css string
            this.themeCss = meevo_bottom_tray + maint_side_nav + nav_buttons_active + nav_buttons + maint_subheader + meevo_button + hover + search_again + mobileSaveButton + mobileHamburger + a11_side_buttons_selected + a11_side_buttons_not_selected + a11_nav_hover + a11_search_again + a11_mil_data_command_tray + a11_meevo_tray_buttons + a11_hamburger + a11_hamburgerButtons;

            const head = document.getElementsByTagName('head')[0];
            const dataMaintElement = document.getElementById("dataMaintStyle")
            if (dataMaintElement) {
                dataMaintElement.remove();
            }
            const style = document.createElement('style');
            const css = this.themeCss;
            style.type = 'text/css';
            style.id = "dataMaintStyle"
            style.appendChild(document.createTextNode(css));
            head.appendChild(style);


        }

        public updateModel(): void {
            let businessTypeId = null;
            if (Model.Guard.isSomething(this.model.businessTypeDetail))
                businessTypeId = this.model.businessTypeDetail.id;
            else
                return;
            let uri = `/${Meevo.AppSettings.Default.API_ROOT}/${Meevo.AppSettings.Default.API_ENDPOINTS.meevoTheming}`;
            if (Model.Guard.isSomething(this.model.businessTypeDetail)) {
                this.model.businessTypeId = this.model.businessTypeDetail.id;

                let parameters = {
                    businessTypeId: this.model.businessTypeId
                }
                this.dataService.customMethodData(uri, 'GET', '', '').then((results: any) => {
                    let temp = this.model.businessTypeDetail;
                    this.model = results.data;
                    this.model.businessTypeDetail = temp;
                });
            }
        }

        protected sendCss(): angular.IPromise<any> {

            let uri = `/storagedrv/${this.tenantId}/styles/meevo.json`
            this.previoustheme = this.themeSelected;

            this.respObj.css["dataMaintTheme"] = this.themeCss;
            this.respObj.colors["dataMaintTheme"] = this.themeSelected;

            let data = this.respObj;

            return this.dataService.customMethodData(uri, 'POST', data, '')
                .then((response) => response.data).catch((err: any) => { console.log("getThemeCss"); });
        }
    }
}
